import { Account } from '@air/api';
import { isAirrorInstance } from '@air/utils-error';

export const accountSSOOptionsFetcher = async ({ email }: { email: string }) => {
  const result = await Account.getAccountSSOOptionsV2({ email });

  if (isAirrorInstance(result)) {
    throw new Error(result.message);
  }

  return result.data || [];
};
